import { PortariaResponsavelForm } from '../../models/portaria.model';

export class PortariaParametrizacaoModalService {
  static $inject = ['$uibModal'];

  constructor(public $uibModal: ng.ui.bootstrap.IModalService) {}

  open(entity: PortariaResponsavelForm) {
    return this.$uibModal.open({
      template: require('html-loader!./portaria-parametrizacao.modal.html'),
      controller: 'PortariaParametrizacaoModalController',
      controllerAs: '$ctrl',
      backdrop: 'static',
      resolve: {
        entity: () => entity
      }
    });
  }
}
